import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-31e41863")

_pushScopeId("data-v-31e41863")
const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = {
  key: 1,
  class: "container"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")

  return (_ctx.waiting)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_LoadingSpinner)
      ]))
    : (_openBlock(), _createBlock("div", _hoisted_2, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.property.state.properties, ([prop,enabled]) => {
          return (_openBlock(), _createBlock("label", {
            key: prop.label,
            class: { 'checked': enabled }
          }, [
            _createVNode("input", {
              type: "checkbox",
              checked: enabled,
              onChange: ($event: any) => (_ctx.property.setPropertyEnabled(prop,!enabled))
            }, null, 40, ["checked", "onChange"]),
            _createTextVNode(" " + _toDisplayString(prop.label), 1)
          ], 2))
        }), 128))
      ]))
})